export default __webpack_public_path__ + "static/media/zoob.443eb83f.jpeg";